export default __webpack_public_path__ + "static/media/pregunta.217f00d0.png";